import dashboards from './dashboards'
import widgets from './widgets'

export type { WidgetUpdateModel, WidgetCreateModel } from './widgets'
export default {
  dashboards,
  widgets,
}
